<script setup>
import { computed } from "vue";
import { storeToRefs } from "pinia";
import { useCompanyStore } from "@/storePinia/company";
import AlertApp from "@/components/common/other/AlertApp.vue";

const SMS_BALANCE_ALERT_THRESHOLD = 20 * 100;

const companyStore = useCompanyStore();
const { company, pendingInvoicesCount } = storeToRefs(companyStore);

const isVisibleUnpaidInvoices = computed(() => pendingInvoicesCount.value > 0);

const isVisibleSms = computed(() => {
  const hasSmsEnabled =
    company.value.remindBeforeEnabled ||
    company.value.smsNotifyOnNewServiceOrderFromClient ||
    company.value.smsNotifyOnNewServiceOrderFromApp ||
    company.value.smsNotifyOnServiceOrderFeedback;

  return (
    hasSmsEnabled &&
    (company.value.smsBalance ?? 0) <= SMS_BALANCE_ALERT_THRESHOLD
  );
});
</script>

<template>
  <div v-if="isVisibleUnpaidInvoices || isVisibleSms" class="header-alerts">
    <AlertApp
      v-if="isVisibleUnpaidInvoices"
      type="warning"
      class="header-alerts__item"
      role="status"
    >
      <template #text>
        <span class="text-sm">
          У вас є несплачені рахунки. Щоб уникнути блокування акаунта, оплатіть
          рахунок.
          <router-link
            :to="{ path: '/subscription', query: { tab: 'invoices' } }"
            class="header-alerts__link"
            >Оплатити</router-link
          >
        </span>
      </template>
    </AlertApp>

    <AlertApp
      v-if="isVisibleSms"
      type="warning"
      class="header-alerts__item"
      role="status"
    >
      <template #text>
        <span class="text-sm">
          У вас критично низький баланс SMS.
          <router-link
            to="/integrations/sms-payment"
            class="header-alerts__link"
            >Поповніть рахунок</router-link
          >, або
          <router-link
            to="/integrations/sms-settings"
            class="header-alerts__link"
            >вимкніть SMS</router-link
          >
          щоб уникнути проблем з доставкою повідомлень.
        </span>
      </template>
    </AlertApp>
  </div>
</template>

<style scoped>
.header-alerts__item {
  margin: 0;
}

.header-alerts__item :deep(.alert__inner) {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  column-gap: 8px;
  width: 100%;
  border-radius: 0;
  padding: 8px 12px;
}

.header-alerts__item + .header-alerts__item {
  margin: 0;
}

.header-alerts__item :deep(.alert__inner) {
  border-top: 1px solid rgba(0, 0, 0, 0.12);
}

.header-alerts__link {
  color: inherit;
  font-weight: 600;
  text-decoration: underline;
}
</style>
